import { rtcBufferActions } from '../../../redux/actions';
import { updateGrid, addToGrid, changeGrid, deleteFromGrid, changeLayer, changeOrder } from '../../../services/grids';

export default class GridNetwork {
    
    constructor() {
        this.controller = null;
        this.tableId = null;
        this.gridId = null;
        this.activeGridId = null;
        this.propsGrid = null;
        this.dispatch = null;
    }

    setController(ctrl) {
        this.controller = ctrl;
    }

    setDispatch(dispatch) {
        this.dispatch = dispatch;
    }

    setTableId(tableId) {
        this.tableId = tableId;
    }

    setGridId(gridId) {
        this.gridId = gridId;
    }

    setActiveGridId(gridId) {
        this.activeGridId = gridId;
        this.propagate();
    }

    setPropsGrid(propsGrid) {
        this.propsGrid = propsGrid;
        this.propagatePropsChange();
    }

    async persist() {
        if (this.gridId) {
            await updateGrid(this.tableId, {
                id: this.gridId,
                render: JSON.stringify(this.controller.exportRender()),
                layers: JSON.stringify(this.controller.exportLayers())
            });
        }
    }

    async persistInsert() {
        if (this.gridId) {
            let items = this.controller.getInsertedItems();
            if (items) {
                await addToGrid(this.tableId, this.gridId, items, this.controller.getCurrentLayer(), this.controller.exportLayers());
            }
        }
    }

    async persistUpdate() {
        if (this.gridId) {
            await changeGrid(this.tableId, this.gridId, this.controller.getUpdatedItems(), this.controller.getCurrentLayer(), this.controller.exportLayers());
        }
    }

    async persistDelete() {
        if (this.gridId) {
            await deleteFromGrid(this.tableId, this.gridId, this.controller.getUpdatedItems(), this.controller.getCurrentLayer(), this.controller.exportLayers());
        }
    }

    async persistChangeLayer() {
        if (this.gridId) {
            await changeLayer(this.tableId, this.gridId, this.controller.getUpdatedItems(), this.controller.getCurrentLayer());
        }
    }

    async persistChangeOrder(distance) {
        if (this.gridId) {
            await changeOrder(this.tableId, this.gridId, this.controller.getUpdatedItems(), this.controller.getCurrentLayer(), distance);
        }
    }

    propagate() {
        if (this.activeGridId === this.gridId) {
            this.dispatch(rtcBufferActions.pushOutputBuffer({
                type: 'gridSync',
                data: this.controller.exportRender()
            }));
        }
    }

    propagatePropsChange() {
        if (this.propsGrid && this.activeGridId === this.propsGrid.id) {
            this.dispatch(rtcBufferActions.pushOutputBuffer({
                type: 'propsGridSync',
                data: this.propsGrid
            }));
        }
    }

    propagateInsert() {
        if (this.activeGridId === this.gridId) {
            let items = this.controller.getInsertedItems();
            if (items) {
                this.dispatch(rtcBufferActions.pushOutputBuffer({
                    type: 'gridSyncInsert',
                    data: {
                        items: items,
                        layer: this.controller.getCurrentLayer()
                    }
                }));
            }
        }
    }

    propagateUpdate() {
        if (this.activeGridId === this.gridId) {
            this.dispatch(rtcBufferActions.pushOutputBuffer({
                type: 'gridSyncUpdate',
                data: {
                    items: this.controller.getUpdatedItems(),
                    layer: this.controller.getCurrentLayer()
                }
            }));
        }
    }

    propagateDelete() {
        if (this.activeGridId === this.gridId) {
            this.dispatch(rtcBufferActions.pushOutputBuffer({
                type: 'gridSyncDelete',
                data: {
                    items: this.controller.getUpdatedItems(),
                    layer: this.controller.getCurrentLayer()
                }
            }));
        }
    }

    propagateChangeLayer() {
        if (this.activeGridId === this.gridId) {
            this.dispatch(rtcBufferActions.pushOutputBuffer({
                type: 'gridSyncChangeLayer',
                data: {
                    items: this.controller.getUpdatedItems(),
                    layer: this.controller.getCurrentLayer()
                }
            }));
        }
    }

    propagateChangeOrder(distance) {
        if (this.activeGridId === this.gridId) {
            this.dispatch(rtcBufferActions.pushOutputBuffer({
                type: 'gridSyncChangeOrderr',
                data: {
                    items: this.controller.getUpdatedItems(),
                    layer: this.controller.getCurrentLayer(),
                    distance: distance
                }
            }));
        }
    }

    sendSignal(point, color) {
        this.dispatch(rtcBufferActions.pushOutputBuffer({
            type: 'signalSync',
            data: [point, color]
        }));
    }

    sendMeasure(measure) {
        this.dispatch(rtcBufferActions.pushOutputBuffer({
            type: 'measureSync',
            data: {...measure.export()}
        }));
    }

    sendMoving(moving) {
        this.dispatch(rtcBufferActions.pushOutputBuffer({
            type: 'movingSync',
            data: [...moving]
        }));
    }

    clearMeasure(id) {
        this.dispatch(rtcBufferActions.pushOutputBuffer({
            type: 'measureClear',
            data: id
        }));
    }
}